import InventoryListingBadges from './InventoryListingBadges';
export default InventoryListingBadges;